import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useApp } from "../context/AppContext";
import client from "../lib/api";
import { MarketingNav } from "./Marketing";
import BrandFooter from "../components/BrandFooter";
import FamiligiReplicaTour from "./FamiligiReplicaTour";
import ModuleReplicaTour from "./ModuleReplicaTour";
import FullSuiteTour from "./FullSuiteTour";
import { LANGS } from "../i18n";
import { WATCH_APPS } from "./watchScripts";
import { Play, Languages, Volume2 } from "lucide-react";

export default function WatchDemo() {
  const { lang, setLang } = useApp();
  const [params] = useSearchParams();
  const initial = WATCH_APPS.some((a) => a.key === params.get("app")) ? params.get("app") : "family_tree";
  const [app, setApp] = useState(initial);
  const [ui, setUi] = useState({});
  useEffect(() => {
    if (lang === "ENG") { setUi({}); return; }
    client.get("/site/demo-i18n", { params: { lang } }).then((r) => setUi(r.data.ui || {})).catch(() => setUi({}));
  }, [lang]);
  const L = (k, fb) => ui[k] || fb;

  return (
    <div className="min-h-screen" style={{ background: "var(--app-bg,#F4F4F4)" }} data-testid="watch-demo-page">
      <MarketingNav />
      <main className="mx-auto max-w-6xl px-5 py-8">
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex items-center gap-2">
            <Play size={22} className="text-[var(--primary)]" />
            <h1 className="font-head text-3xl">{L("watch_demo", "Watch Demo")}</h1>
            <span data-testid="watch-narrated-badge" className="inline-flex items-center gap-1 rounded-full border border-[var(--primary)]/30 bg-[var(--primary)]/10 px-2 py-1 text-[11px] font-medium text-[var(--primary)]">
              <Volume2 size={12} /> {L("narrated_badge", "Narrated — press Voice to listen")}
            </span>
          </div>
          <div className="ms-auto flex items-center gap-1.5 rounded-md border border-black/15 px-2 py-1 dark:border-white/15">
            <Languages size={14} className="text-[var(--primary)]" />
            <select value={lang} onChange={(e) => setLang(e.target.value)} data-testid="watch-language-select" className="bg-transparent text-xs outline-none">
              {LANGS.map((l) => <option key={l.code} value={l.code}>{l.native}</option>)}
            </select>
          </div>
        </div>

        <div className="mt-4 flex flex-wrap gap-2" data-testid="watch-app-tabs">
          {WATCH_APPS.map((a) => (
            <button key={a.key} onClick={() => setApp(a.key)} data-testid={`watch-tab-${a.key}`}
              className={`rounded-full px-4 py-1.5 text-sm font-medium lift ${app === a.key ? "bg-[var(--primary)] text-white" : "border border-black/15 dark:border-white/15 hover:bg-black/5"}`}>
              {a.brand}
            </button>
          ))}
        </div>

        <div className="mt-6" key={`${app}-${lang}`}>
          {app === "suite" ? <FullSuiteTour />
            : app === "family_tree" ? <FamiligiReplicaTour />
            : <ModuleReplicaTour app={app} />}
        </div>

        <div className="mt-3"><Link to="/solutions" className="text-sm text-[var(--primary)] hover:underline" data-testid="watch-back">← {L("back_to_solutions", "Back to Solutions")}</Link></div>
      </main>
      <BrandFooter />
    </div>
  );
}
